export { ProfilesCompanyModule } from './profiles-company.module';
export { ProfileService } from './services/profile.service';
